<template>
  <div class="teachin-global-settings">
    <div class="teachin-global-settings__item" v-for="(setting, index) in list">
      <template v-if="setting.type === 'boolean'">
            <Checkbox :isSimple="false" :label="$t(setting.label)" :value="setting.value" @updatedValue="syncBooleanSettings(index, $event)" />
          </template>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import Checkbox from '../../../components/ui-elements/Checkbox.vue';

  export default {
    name: 'TeachinSettings',
    components: {Checkbox},
    props:{
      settings:{
        type: Array,
      }
    },
    created(){

    },
    data(){
      return {
        list: []
      };
    },
    computed: {

    },
    watch:{
      settings:{
        handler(value){
          this.init();
        },
        deep: true,
        immediate: true
      }
    },
    methods:{
      init(){
        this.list = cloneDeep(this.settings);
      },
      syncBooleanSettings(index, value){
        this.list[index] = Object.assign(this.list[index], {value});
        this.$emit('syncSettings', cloneDeep(this.list));
      }
    }
  }
</script>

<style lang="scss" scoped>
.teachin-global-settings{
  display: flex;
  flex-wrap: wrap;

  &__item{
    flex: 0 1 50%;
    display: flex;
    flex-wrap: wrap;
    word-break: break-all;

    @media (max-width: 650px) {
      flex: 1 1 100%;
    }
  }
}
</style>
